var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.color,"size":"30"}},[(_vm.user)?_c('span',{staticClass:"user-initials",staticStyle:{"color":"var(--v-info-darken2)"},domProps:{"textContent":_vm._s(_vm.initials)}}):_c('img',{staticStyle:{"width":"20px","height":"20px"},attrs:{"src":"/img/bot-white-full.png"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }